export default __webpack_public_path__ + "assets/icons/iconNoData.fd3e08ee.svg";